import RegistrationTitleSection from "@/containers/registration/components/RegistrationTitleSection";
import { tossColor } from "@/containers/Toss/constants/color";
import { Box, Select, Checkbox } from "@chakra-ui/react";
import {
  Button,
  ColorIcon,
  colors,
  customEvent,
  HStack,
  OverlayModal,
  VStack,
  responsive,
  Field,
} from "goi_common";
import countryCodes from "@/constants/sens_country_codes_split_us_ca.json";
import { koreaCountry } from "@/constants/korea_country_code";
import { useState } from "react";
import TextField from "@/components/common/TextField";

import { useRouter } from "next/router";
import { useOverlay } from "@toss/use-overlay";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { sessionStorage } from "@/utils/storage";
import { Axios } from "@/utils/axios";

dayjs.extend(utc);
dayjs.extend(timezone);

const postPrimeCallLead = async (phone: string, text: string) => {
  const data = {
    phone,
    memo: text,
  };

  try {
    await Axios.post("/advance_pay_customers/call_leads/", data);
  } catch (error) {
    console.error("Failed to post call lead:", error);
    throw error;
  }
};

export default function CallLead() {
  const [selectedCountry, setSelectedCountry] = useState(koreaCountry);
  const [phone, setPhone] = useState("");

  const [privateAgree, setPrivateAgree] = useState(false);
  const [marketingAgree, setMarketingAgree] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  const [장례경험, set장례경험] = useState<string>("");
  const [상조경험, set상조경험] = useState<string>("");
  const [궁금한점, set궁금한점] = useState<string>("");
  const [기타메모, set기타메모] = useState<string>("");

  const router = useRouter();

  const isTossProcess = router.query.isToss === "true";
  const firstVisitPath = sessionStorage.get("firstVisitPath");

  const isOverseas = firstVisitPath === "home_overseas";

  const overlay = useOverlay();

  const submitPhoneNumber = () => {
    if (!privateAgree) {
      alert("개인정보 수집 및 이용에 동의해주세요.");
      return;
    }
    if (loading) return;
    if (!phone) {
      alert(
        isOverseas ? "이메일을 입력해주세요." : "핸드폰 번호를 입력해주세요."
      );
      return;
    }
    if (!장례경험 || !상조경험 || !궁금한점) {
      alert("3가지 항목 모두 선택해주세요.");
      return;
    }
    customEvent({
      newGtm: {
        path: "call_lead",
        trigger_and_target: "submit_call_lead",
      },
    });

    setLoading(true);

    const messageText = `${
      firstVisitPath ? `최초 방문 페이지: ${firstVisitPath}` : ""
    }\n장례경험: ${장례경험}\n상조경험: ${상조경험}\n궁금한점: ${궁금한점}\n기타메모: ${기타메모}\n개인정보 수집 및 이용 동의: ${privateAgree}\n마케팅 정보 수신 동의: ${marketingAgree}
`;

    postPrimeCallLead(
      selectedCountry.country_code === "010"
        ? "010" + phone
        : `+${selectedCountry.country_code} ${phone}`,
      messageText
    )
      .then(() => {
        overlay.open(({ isOpen: isOpen2, close: onClose2 }) => {
          return (
            <OverlayModal
              isOpen={isOpen2}
              modalContentStyle={{
                minWidth: "330px",
                maxWidth: "330px",
                margin: "0 20px",
                minHeight: "none",
                borderRadius: "10px",
              }}
              overlayModalContent={
                <VStack padding="14px 16px 20px" gap="20px" alignItems="center">
                  <HStack justifyContent="flex-end" width="100%">
                    <Box
                      onClick={() => {
                        onClose2();
                      }}
                    >
                      <ColorIcon
                        name="icon-x-mono"
                        color={colors.gray700}
                        size={20}
                      />
                    </Box>
                  </HStack>

                  <>
                    <Box className="black subtitle_21_b">
                      신청이 완료되었습니다
                    </Box>
                    <Box>
                      고객님께{" "}
                      {dayjs().day() === 0 || dayjs().day() === 6
                        ? "영업일 내 "
                        : ""}
                      빠르게 연락드리겠습니다.
                      <br /> 잠시만 기다려주세요.
                    </Box>
                    <Button
                      className="white button"
                      onClick={() => {
                        router.back();
                        onClose2();
                      }}
                      css={{
                        background: isTossProcess
                          ? tossColor["700"]
                          : colors.orange650,
                        height: "48px",
                        borderRadius: "8px",
                        fontWeight: "700",
                        width: "100%",
                      }}
                    >
                      나가기
                    </Button>
                  </>
                </VStack>
              }
              onClose={() => {
                onClose2();
              }}
            />
          );
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <HStack justifyContent="center">
      <VStack
        css={responsive({
          padding: { base: "0px", md: "0px" },
          maxWidth: "480px",
          width: "100%",
          minHeight: "calc(100dvh - 74px)",
          position: "relative",
        })}
      >
        <VStack padding="10px 20px 160px">
          <HStack padding="0 0 20px 0" justifyContent="space-between">
            <HStack
              onClick={() => {
                router.back();
              }}
            >
              <ColorIcon
                name="icon-service-arrow-right-line"
                size={30}
                color={colors.gray500}
                css={{ transform: "rotate(180deg)" }}
              />
            </HStack>
          </HStack>
          <VStack>
            <RegistrationTitleSection
              title={"고객님이 궁금하신 내용을\n 모두 안내해드릴게요"}
              pageName="상담 신청하기"
              description={`알려주신 연락처는 정보를 안내드리기 위해 필요할 뿐,\n관련 없는 곳에는 사용하지 않아요.`}
              color={isTossProcess ? tossColor["700"] : colors.orange650}
            />
          </VStack>

          <VStack gap="8px" padding="36px 0">
            <span
              className="subtitle2_b"
              css={{
                color: isTossProcess ? tossColor["700"] : colors.orange650,
              }}
            >
              전화 번호
            </span>
            <HStack
              width="100%"
              justifyContent="space-between"
              alignItems="center"
            >
              <VStack gap="4px" width="100%">
                <HStack
                  gap="8px"
                  width="100%"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Select
                    value={selectedCountry.country_code}
                    fontSize="14px"
                    onChange={(e) => {
                      const newCountry =
                        e.target.value === "010"
                          ? koreaCountry
                          : countryCodes.find(
                              (c) => c.country_code === e.target.value
                            ) || koreaCountry;
                      setSelectedCountry(newCountry);
                    }}
                    width="150px"
                    flexShrink={0}
                  >
                    <option value="010">+82 010(한국)</option>
                    {countryCodes.map(
                      (c) =>
                        c.sms_available && (
                          <option
                            key={c.country_code + c.iso_code}
                            value={c.country_code}
                          >
                            +{c.country_code} ({c.localized_name})
                          </option>
                        )
                    )}
                  </Select>
                  <Box flex={1}>
                    <TextField
                      borderColor={
                        isTossProcess ? tossColor["700"] : colors.orange650
                      }
                      value={phone}
                      onChange={(event) =>
                        setPhone(event.target.value.replaceAll("-", ""))
                      }
                      placeholder={
                        selectedCountry.country_code === "010"
                          ? "12341234"
                          : "전화번호 입력"
                      }
                      width="100%"
                    />
                  </Box>
                </HStack>
              </VStack>
            </HStack>
            <VStack gap="8px" width="100%">
              <HStack
                alignItems="center"
                gap="2px"
                width="100%"
                justifyContent="space-between"
              >
                <Checkbox
                  isChecked={privateAgree && marketingAgree}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setPrivateAgree(checked);
                    setMarketingAgree(checked);
                  }}
                  size="md"
                  sx={{
                    ".chakra-checkbox__control": {
                      bg: "gray.100",
                      borderColor: "gray.300",
                      _checked: {
                        bg: isTossProcess ? tossColor["700"] : colors.orange650,
                        borderColor: isTossProcess
                          ? tossColor["700"]
                          : colors.orange650,
                      },
                    },
                    ".chakra-checkbox__label": {
                      fontSize: "14px",
                    },
                  }}
                >
                  전체 동의 / 개인정보 수집 및 마케팅 수신
                </Checkbox>
                <Box
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  css={{
                    cursor: "pointer",
                    transform: isDropdownOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.2s ease-in-out",
                  }}
                >
                  <ColorIcon
                    name="arrow-drop-down"
                    size={12}
                    color={colors.gray400}
                  />
                </Box>
              </HStack>
              {isDropdownOpen && (
                <VStack gap="8px" width="100%" css={{ paddingLeft: "18px" }}>
                  <HStack alignItems="center" gap="2px" width="100%">
                    <Checkbox
                      isChecked={privateAgree}
                      onChange={(e) => {
                        setPrivateAgree(e.target.checked);
                      }}
                      size="md"
                      sx={{
                        ".chakra-checkbox__control": {
                          bg: "gray.100",
                          borderColor: "gray.300",
                          _checked: {
                            bg: isTossProcess
                              ? tossColor["700"]
                              : colors.orange650,
                            borderColor: isTossProcess
                              ? tossColor["700"]
                              : colors.orange650,
                          },
                        },
                        ".chakra-checkbox__label": {
                          fontSize: "14px",
                        },
                      }}
                    >
                      개인정보 수집 및 이용 동의 (필수)
                    </Checkbox>
                  </HStack>
                  <HStack alignItems="center" gap="2px" width="100%">
                    <Checkbox
                      isChecked={marketingAgree}
                      onChange={(e) => {
                        setMarketingAgree(e.target.checked);
                      }}
                      size="md"
                      sx={{
                        ".chakra-checkbox__control": {
                          bg: "gray.100",
                          borderColor: "gray.300",
                          _checked: {
                            bg: isTossProcess
                              ? tossColor["700"]
                              : colors.orange650,
                            borderColor: isTossProcess
                              ? tossColor["700"]
                              : colors.orange650,
                          },
                        },
                        ".chakra-checkbox__label": {
                          fontSize: "14px",
                        },
                      }}
                    >
                      마케팅 정보 수신 동의 (선택)
                    </Checkbox>
                  </HStack>
                </VStack>
              )}
            </VStack>
          </VStack>

          <VStack gap="32px">
            <Field.Radio
              title="장례를 치러본 경험이 있으신가요?"
              items={[
                "상주로 치러본 적 있어요",
                "아직 상주로 치러본 적 없어요",
                "상주는 아니였으나, 가족의 장례를 경험했어요",
              ]}
              value={장례경험}
              radioWidth="100%"
              onChange={set장례경험}
            />
            <Field.Radio
              title="상조 가입 경험이 있으신가요?"
              items={[
                "가입 상조가 따로 있어요",
                "가입했으나 필요 없을 것 같아 해지했어요",
                "상조 폐업, 회사 퇴직 등으로 현재는 없어요",
                "가입 경험이 없어요",
              ]}
              value={상조경험}
              radioWidth="100%"
              onChange={set상조경험}
            />
            <Field.Radio
              title="어떤 부분이 가장 궁금하세요?"
              items={[
                "장례식장 추천 등 전반적인 장례 준비가 필요해요",
                "가입한 타상조 상품 비교/해지가 고민이에요",
                "100원 상조 보장 내역 및 설명이 필요해요",
                "여행, 웨딩 등 다른 멤버십은 없는지 궁금해요",
              ]}
              value={궁금한점}
              radioWidth="100%"
              onChange={set궁금한점}
            />
            <Field.Textarea
              title="기타 궁금한 점을 적어주세요(선택)"
              value={기타메모}
              onChange={(e) => set기타메모(e.target.value)}
            />
          </VStack>

          {/* <Box
            className="subtitle_16_b"
            color={isTossProcess ? tossColor["700"] : colors.orange650}
            padding="0 0 12px 0"
          >
            상담을 받으시면 아래같은 질문을 해소하실 수 있어요.
          </Box>
          <VStack gap="18px">
            <HStack alignItems="center" gap="12px">
              <Box
                width="32px"
                height="32px"
                backgroundColor={colors.gray900}
                color={colors.white}
                borderRadius="50%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontWeight="700"
                flexShrink={0}
              >
                1
              </Box>
              <VStack>
                <Box className="subtitle_16_b">100원 상조 뭘 보장해주나요?</Box>
                <Box className="body_14_r gray700">
                  100원 상조 가격부터 해지 조건까지 자세히 알려드립니다.
                </Box>
              </VStack>
            </HStack>
            <HStack alignItems="center" gap="12px">
              <Box
                width="32px"
                height="32px"
                backgroundColor={colors.gray900}
                color={colors.white}
                borderRadius="50%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontWeight="700"
                flexShrink={0}
              >
                2
              </Box>
              <VStack>
                <Box className="subtitle_16_b">
                  장례 준비, 어디서부터 해야하죠?
                </Box>
                <Box className="body_14_r gray700">
                  장례전문가가 전체 장례 비용, 절차 등 처음부터 차근히
                  알려드립니다.
                </Box>
              </VStack>
            </HStack>
            <HStack alignItems="center" gap="12px">
              <Box
                width="32px"
                height="32px"
                backgroundColor={colors.gray900}
                color={colors.white}
                borderRadius="50%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontWeight="700"
                flexShrink={0}
              >
                3
              </Box>
              <VStack>
                <Box className="subtitle_16_b">
                  월 100원 받고 나중에 추가금 받는 거 아니에요?
                </Box>
                <Box className="body_14_r gray700">
                  추가금 받을 경우 100% 환불 제도 등 보장 내용을 상세히
                  안내드립니다.
                </Box>
              </VStack>
            </HStack>
          </VStack> */}
        </VStack>
        <Box
          css={{
            position: "fixed",
            bottom: 0,
            maxWidth: "480px",
            width: "100%",
            padding: "10px 10px",
            background: "#ffffff",
            "&::before": {
              content: '""',
              position: "absolute",
              bottom: "100%",
              left: 0,
              right: 0,
              height: "40px",
              background:
                "linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))",
              pointerEvents: "none",
            },
          }}
        >
          <Button
            css={{
              width: "100%",
              height: "48px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "700",
              color: colors.white,
              background: isTossProcess ? tossColor["700"] : colors.orange650,
            }}
            onClick={submitPhoneNumber}
          >
            전문가에게 무료 상담 받기
          </Button>
        </Box>
      </VStack>
    </HStack>
  );
}
